<template>
    <i
        class="l-ss-c-offer-compare-icon"
        :class="{
            'l-ss-c-offer-compare-icon-active': isCompareOffer
        }"
        :style="style"
        v-html="currentIcon"
        @click.prevent.stop="clickOnAddToCompareHandler($event)"></i>
</template>

<script>
    import { computed } from '@vue/composition-api';

    import iconCompare from '@/core/assets/images/icons/compare.svg';
    import useOfferCompareController from '@/core/components/offer/offer-compare/use-offer-compare-controller';

    export default {
        props: {
            offer: {
                type: Object,
            },
            settings: {
                type: Object,
            },
            compareSettings: {
                type: Object,
            },
        },
        setup(props, { emit }) {
            const { offer, settings, compareSettings } = props;
            const { style, icon } = settings;

            const currentIcon = computed(() => {
                if (icon && icon.default) {
                    const defaultIcon = icon.default;
                    const activeIcon = icon.active;

                    if (isCompareOffer.value) {
                        return activeIcon || defaultIcon;
                    } else {
                        return defaultIcon;
                    }
                }

                return iconCompare;
            });

            const emitAddToCompare = (event) => {
                emit('add-to-compare-click', event);
            };

            const emitRemoveFromCompare = (event) => {
                emit('remove-from-compare-click', event);
            };

            const clickOnAddToCompareHandler = (event) => {
                const actionType = isCompareOffer.value ? 'removeFromCompare' : 'addToCompare';

                if (actionType === 'addToCompare') {
                    emitAddToCompare(event);
                } else {
                    emitRemoveFromCompare(event);
                }
                onChange(!isCompareOffer.value);
            };

            const { isCompareOffer, onChange } = useOfferCompareController(offer, compareSettings);

            return {
                currentIcon,
                style,
                isCompareOffer,
                onChange,
                clickOnAddToCompareHandler,
            };
        },
    };
</script>

<style scoped>

</style>
